import { CheckmarkFilled, CloseFilled, HourFilled } from '@icon';
import {
  ListItem,
  ListItemAvatarInitialsLeft,
  ListItemRightTitleDescIcon,
  ListItemStateRight,
} from '@ui';
import moment from 'moment';
import React from 'react';
import { IPatientPrescriptionRequest } from 'types/e-prescription.types';

interface PrescriptionsPatientsListItemProps {
  item: IPatientPrescriptionRequest;
}

const PrescriptionsPatientsListItem = (
  { item }: PrescriptionsPatientsListItemProps,
  ref?: React.Ref<HTMLDivElement>,
) => {
  return (
    <ListItem
      ref={ref}
      style={{ paddingLeft: 24, paddingRight: 24 }}
      left={
        <ListItemAvatarInitialsLeft
          style={{ alignSelf: 'flex-start' }}
          initials={ListItemAvatarInitialsLeft.fromString(item.allowedDrugReceiptItem.name)}
        />
      }
      right={
        item.approved === null ? (
          <ListItemStateRight
            Icon={HourFilled}
            state="waiting"
            style={{ alignSelf: 'flex-start' }}
          />
        ) : item.approved ? (
          <ListItemStateRight
            Icon={CheckmarkFilled}
            state="success"
            style={{ alignSelf: 'flex-start' }}
          />
        ) : (
          <ListItemStateRight
            Icon={CloseFilled}
            state="error"
            style={{ alignSelf: 'flex-start' }}
          />
        )
      }
    >
      <ListItemRightTitleDescIcon
        title={item.allowedDrugReceiptItem.name}
        description={moment(item.createdAt).format('LL')}
      />
    </ListItem>
  );
};

export default React.memo(React.forwardRef(PrescriptionsPatientsListItem));
